module.exports = __webpack_public_path__ + "static/img/rank_background2.15133228.png";